import React from 'react';
import PropTypes from 'prop-types';

import { map } from 'lodash-es';

import FieldBirthDate from '../../Common/Fields/FieldBirthDate';
import FieldDate from '../../Common/Fields/FieldDate';
import FieldInput from '../../Common/Fields/FieldInput';
import FieldInputPercent from '../../Common/Fields/FieldInputPercent';
import FieldInputPhone from '../../Common/Fields/FieldInputPhone';
import FieldRadioGroup from '../../Common/Fields/FieldRadioGroup';
import FieldInputSsn from '../../Common/Fields/FieldInputSsn';
import FieldSelect from '../../Common/Fields/FieldSelect';
import FieldInputNumber from '../../Common/Fields/FieldInputNumber';

import FieldTextArea from './FieldTextArea';

import { TypesFieldEnum, WebInputField } from '../QuotationBlock.enum';

/**
 * handle field
 * @returns {XML}
 * @constructor
 */
const HandleFields = ({
  code,
  disabled,
  type,
  selection,
  webInput,
  validate,
  existError,
  showError,
  handleBlur,
  param,
  thousandSeparator,
  decimalSeparator,
}) => {
  switch (type) {
    case TypesFieldEnum.DATE:
      return (
        <FieldDate
          code={code}
          disabled={disabled}
          existError={existError}
          showError={showError}
          validate={validate}
          handleBlur={handleBlur}
          param={param}
        />
      );
    case TypesFieldEnum.BIRTH_DATE:
      return (
        <FieldBirthDate
          code={code}
          disabled={disabled}
          existError={existError}
          showError={showError}
          validate={validate}
          handleBlur={handleBlur}
          param={param}
        />
      );
    case TypesFieldEnum.NUMBER:
    case TypesFieldEnum.INTEGER:
      return (
        <FieldInputNumber
          code={code}
          disabled={disabled}
          validate={validate}
          existError={existError}
          showError={showError}
          handleBlur={handleBlur}
          thousandSeparator={thousandSeparator}
          decimalSeparator={decimalSeparator}
        />
      );
    case TypesFieldEnum.PERCENTAGE:
      return (
        <FieldInputPercent
          code={code}
          disabled={disabled}
          decimalScale={0}
          validate={validate}
          existError={existError}
          showError={showError}
          handleBlur={handleBlur}
          thousandSeparator={thousandSeparator}
          decimalSeparator={decimalSeparator}
        />
      );
    case TypesFieldEnum.TEXT:
    case TypesFieldEnum.EMAIL:
      return (
        <FieldInput
          code={code}
          disabled={disabled}
          type={TypesFieldEnum.TEXT}
          validate={validate}
          existError={existError}
          showError={showError}
          handleBlur={handleBlur}
        />
      );
    case TypesFieldEnum.TEL:
      return (
        <FieldInputPhone
          code={code}
          disabled={disabled}
          validate={validate}
          existError={existError}
          showError={showError}
          handleBlur={handleBlur}
        />
      );
    case TypesFieldEnum.SELECTION:
      switch (webInput) {
        case WebInputField.CHECKBOX: {
          return (
            <FieldRadioGroup
              code={code}
              disabled={disabled}
              selection={selection}
              validate={validate}
              existError={existError}
              showError={showError}
              handleChange={handleBlur}
            />
          );
        }
        default: {
          return (
            <FieldSelect
              code={code}
              disabled={disabled}
              selection={selection}
              validate={validate}
              existError={existError}
              showError={showError}
              handleChange={handleBlur}
            />
          );
        }
      }
    case TypesFieldEnum.SSN:
      return (
        <FieldInputSsn
          code={code}
          disabled={disabled}
          validate={validate}
          existError={existError}
          showError={showError}
          handleBlur={handleBlur}
        />
      );
    case TypesFieldEnum.ADDITIONAL_ADDRESS:
      return (
        <FieldTextArea
          code={code}
          disabled={disabled}
          validate={validate}
          existError={existError}
          showError={showError}
          handleBlur={handleBlur}
        />
      );
    default:
      return <span />;
  }
};

HandleFields.propTypes = {
  code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  type: PropTypes.oneOf(map(TypesFieldEnum, item => item)).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  selection: PropTypes.array,
  webInput: PropTypes.oneOf(map(WebInputField, item => item)),
  disabled: PropTypes.bool,
  validate: PropTypes.func.isRequired,
  existError: PropTypes.bool.isRequired,
  showError: PropTypes.bool.isRequired,
  handleBlur: PropTypes.func.isRequired,
  param: PropTypes.shape({
    min: PropTypes.string,
    max: PropTypes.string,
    methodCalculateAge: PropTypes.string,
  }),
  thousandSeparator: PropTypes.string,
  decimalSeparator: PropTypes.string,
};

HandleFields.defaultProps = {
  selection: undefined,
  webInput: undefined,
  disabled: false,
  param: {},
  thousandSeparator: undefined,
  decimalSeparator: undefined,
};

export default HandleFields;
